// models/Establishment.js
export default class Establishment {
    constructor({
        establishmentId = 0,
        fieldUID = "",
        name = "",
        city = "",
        governorate = "",
        facilityType = "",
        locality = "",
        district = "",
        persons = 0,
        activities = 0,
        externalPhoto = null,
        violationReportsCount = 0,

        // ✅ الحقول الجديدة
        addressText = "",
        closingTime = "",
        createdAt = null,
        createdByUserId = null,
        createdByUsername = "",
        estimatedCapital = null,
        internalPhoto = null,
        lat = null,
        lng = null,
        openingTime = "",
        phone = "",
        photos = [],
        propertyArea = null,
        propertyOwnerName = "",
        propertyType = "",
        ratingOutOfTen = null,
        relations = { incoming: [], outgoing: [] },
        riskScore = null,
        rowVersionBase64 = "",
        salesType = "",
        tradeRegistryNumber = "",
    } = {}) {
        this.establishmentId = establishmentId;
        this.fieldUID = fieldUID;
        this.name = name;
        this.city = city;
        this.governorate = governorate;
        this.facilityType = facilityType;
        this.locality = locality;
        this.district = district;
        this.persons = persons;
        this.activities = activities;
        this.externalPhoto = externalPhoto;

        // ✅ الإضافات
        this.addressText = addressText;
        this.closingTime = closingTime;
        this.createdAt = createdAt;
        this.createdByUserId = createdByUserId;
        this.createdByUsername = createdByUsername;
        this.estimatedCapital = estimatedCapital;
        this.internalPhoto = internalPhoto;
        this.lat = lat;
        this.lng = lng;
        this.openingTime = openingTime;
        this.phone = phone;
        this.photos = photos;
        this.propertyArea = propertyArea;
        this.propertyOwnerName = propertyOwnerName;
        this.propertyType = propertyType;
        this.ratingOutOfTen = ratingOutOfTen;
        this.relations = relations;
        this.riskScore = riskScore;
        this.rowVersionBase64 = rowVersionBase64;
        this.salesType = salesType;
        this.tradeRegistryNumber = tradeRegistryNumber;
        this.violationReportsCount = violationReportsCount;
    }
}
